import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
// @mui
import {
  Stack,
  TextField,
  Button,
  Modal,
  Checkbox,
  FormGroup,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Autocomplete,
  Avatar,
  Box
} from '@mui/material';

import Iconify from '../components/iconify';

import MaskTelefone from './helpers/MaskTelefone';

import config from '../config.json';
import { useUnidades } from '../hooks/useUnidades';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  height: '90vh',
  '@media screen and (max-width: 600px)': {
    width: '100vw', // Width de 100% para telas de celulares
    height: '90vh',
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: '32px',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  overflowX: 'auto',
  backgroundColor: 'azure',
  justifyContent: 'center',
  verticalAlign: 'center'
};

const styleTextField = {
  backgroundColor: 'white',

  '@media screen and (max-width: 600px)': {
    width: 'auto', // Width de 100% para telas de celulares
  },
  verticalAlign: 'center'
};

const modulos = config.modulos

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// ----------------------------------------------------------------------

const AddUsuario = React.forwardRef((props, ref) => {
  const [data, setData] = useState(props.data || {})
  const [showPassword, setShowPassword] = useState(false);
  const { unidades } = useUnidades();
  const fileInputRef = useRef(null);

  const handleFotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    fileToBase64(file).then((base64) => {
      setData((prevData) => ({ ...prevData, foto: base64 }));
    });
  };



  useEffect(() => {
    if (!data._id) {
      if (data.password) {
        setData({ ...data, primeirologin: false })
        return
      }
      setData({ ...data, primeirologin: true })
    }

  }, [data.password])

  const handleChange = (e) => {
    const newValue = e.target.value;
    const property = e.target.id;
    setData({ ...data, [property]: newValue });
  }

  const handleChangeCheck = (e) => {
    setData({ ...data, [e.target.id]: e.target.checked });
  };

  // Ao clicar no confirm executa a funcao da props onConfirm retornando produto para o objeto pai
  const handleConfirm = () => {
    props.onConfirm(data);
  };

  const onClose = () => {
    props.onClose();
  };

  // ----------------------
  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"

    >
      <Stack direction={'column'} sx={style}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', gap: '32px' }}>
          <FormGroup sx={{ width: '100%', alignSelf: 'center' }}>
            <Stack gap={2} >
              <Stack direction={'row'} justifyContent={'center'}>
                <Box sx={{ position: 'relative', width: 120, height: 120 }}>
                  <Avatar
                    src={data.foto || undefined}
                    sx={{ width: 120, height: 120, cursor: 'pointer', border: '2px solid #ccc', fontSize: 48 }}
                    onClick={() => fileInputRef.current.click()}
                  >
                    {!data.foto && (data.nome ? data.nome.charAt(0).toUpperCase() : <Iconify icon="eva:person-fill" width={60} height={60} />)}
                  </Avatar>
                  <IconButton
                    size="small"
                    onClick={() => fileInputRef.current.click()}
                    sx={{ position: 'absolute', bottom: 0, right: 0, backgroundColor: 'white', border: '1px solid #ccc', '&:hover': { backgroundColor: '#f0f0f0' } }}
                  >
                    <Iconify icon="eva:camera-fill" width={18} height={18} />
                  </IconButton>
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    ref={fileInputRef}
                    onChange={handleFotoChange}
                  />
                </Box>
              </Stack>
              <TextField id="nome" label="Nome" variant="outlined" value={data?.nome} onChange={handleChange} sx={styleTextField} />
              <MaskTelefone id="telefone" label="Telefone" variant="outlined" value={data?.telefone} onChange={handleChange} sx={styleTextField} />
              <TextField id="email" label="Email" variant="outlined" value={data?.email} onChange={handleChange} sx={styleTextField} />
              {!data._id ?
                <TextField
                  name="password"
                  id="password"
                  label="Senha"
                  type={showPassword ? 'text' : 'password'}
                  sx={styleTextField}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onChange={handleChange}
                />
                : null}

              {data.password ?
                <TextField
                  name="password"
                  id="confirmpassword"
                  label="Confirmação de Senha"
                  type={showPassword ? 'text' : 'password'}
                  sx={styleTextField}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onChange={handleChange}
                /> : null}

              <Autocomplete
                disablePortal
                id="unidade"
                value={data.unidade || null}
                options={unidades}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                getOptionLabel={(option) => `${option.nome}`}
                sx={styleTextField}
                renderInput={(params) => <TextField {...params} label="Unidade" />}
                onChange={(event, newValue) => {
                  setData((prevData) => ({ ...prevData, unidade: newValue }))
                }}
              />

              <Stack direction={'row'} justifyContent={'space-between'} flexWrap={'wrap'}>
                <FormControlLabel
                  control={<Checkbox id='primeirologin' onChange={handleChangeCheck} checked={data.primeirologin} disabled={Boolean(data.password)} />}
                  label="Primeiro Login"
                  sx={{ minWidth: 150 }}  // Largura mínima
                />
                <FormControlLabel
                  control={<Checkbox id='supervisor' onChange={handleChangeCheck} checked={data.supervisor} />}
                  label="Supervisor"
                  sx={{ minWidth: 150 }}  // Largura mínima
                />
                <FormControlLabel
                  control={<Checkbox id='ativo' onChange={handleChangeCheck} checked={data.ativo} />}
                  label="Ativo"
                  sx={{ minWidth: 150 }}  // Largura mínima
                />



              </Stack>
              <Stack direction={'row'} >
                <FormControlLabel
                  control={<Checkbox id='montador' onChange={handleChangeCheck} checked={data.montador} />}
                  label="Montador"
                // Largura mínima
                />
                {
                  data.montador && <FormControlLabel
                    control={<Checkbox id='montadorexterno' onChange={handleChangeCheck} checked={data.montadorexterno} />}
                    label="Externo"
                  // Largura mínima
                  />
                }
              </Stack>

              <br />
              <br />
              <strong>Módulos Habilitados</strong>
              <Stack direction={'row'} justifyContent={'space-between'} flexWrap={'wrap'}>
                {modulos.map((modulo) => (
                  <FormControlLabel
                    key={modulo.id}
                    control={
                      <Checkbox
                        checked={data.modulos?.some(m => m.id === modulo.id && m.ativo)}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setData((prevData) => {
                            const updatedModulos = prevData.modulos?.map((m) =>
                              m.id === modulo.id ? { ...m, ativo: isChecked } : m
                            ) || [];

                            if (!updatedModulos.some((m) => m.id === modulo.id)) {
                              updatedModulos.push({ id: modulo.id, ativo: isChecked });
                            }

                            return { ...prevData, modulos: updatedModulos };
                          });
                        }}
                      />
                    }
                    label={modulo.nome}
                  // Largura mínima
                  />
                ))}
              </Stack>



            </Stack>
          </FormGroup>

          <Stack direction={'row'} justifyContent={'space-between'} >
            <Button variant="contained" onClick={onClose} color="error"> Cancelar</Button>
            <Button variant="contained" color="success" onClick={handleConfirm}>Salvar</Button>
          </Stack>
        </div>


      </Stack>

    </Modal>
  );
})

AddUsuario.propTypes = {
  produto: PropTypes.object,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onClose: PropTypes.func,


}

export default (AddUsuario);